import { RefiVerifyIdQuiz } from './verify-id-quiz.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../validate-all-fields.js';
import '../../styles/buttons.style.js';

defineRefiElement('refi-verify-id-quiz', RefiVerifyIdQuiz);
